export const isString = (str: any) => {
  return typeof str === "string" || str instanceof String;
};

export const asString = (data: any) => {
  if (!data) {
    return "";
  }

  if (isString(data)) {
    return data;
  }

  return JSON.stringify(data);
};

export const toBase64 = (stringToConvert: string) => {
  return Buffer.from(stringToConvert).toString("base64");
};

export const fromBase64 = (base64String: string) => {
  return Buffer.from(base64String, "base64").toString("utf8");
};

export const isEmpty = (str:any) => {
  return !str || str.length === 0;
};
